import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthConfig, ElderAuthModule, HttpsValidationType } from '@elderbyte/ngx-auth';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

// Because of AOT Compiler
export function createAuthConfig(): AuthConfig {
  console.log('createAuthConfig with env:', environment);

  return {
    issuerUrl: environment.issuerUrl,
    validation: { httpsRequired: HttpsValidationType.None },
    clientId: environment.clientId,
    roleHierarchy: environment.roleHierarchy,
    scope: environment.scope,
    accessDeniedRoute: 'app/accessdenied',
    mock: {
      enable: !environment.issuerUrl
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      defaultLanguage: 'de'
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    importProvidersFrom(
      ElderAuthModule.forRootDynamic({
        provide: AuthConfig,
        useFactory: createAuthConfig
      })
    )
  ]
};
